export { default } from './CortexLink';
